import gql from 'graphql-tag';

export const createExchangeMutation = gql`
    mutation($organizationId: String!, $currencyFrom: String!, $currencyTo: String!, $amountFrom: Float!, $successWebhook: String, $errorWebhook: String) {
        createExchange(organizationId: $organizationId, currencyFrom: $currencyFrom, currencyTo: $currencyTo, amountFrom: $amountFrom, successWebhook: $successWebhook, errorWebhook: $errorWebhook) {
            id
        }
    }
`;
